import { getCookie, setCookie } from "@/services/cookies";
import { CookieName, CookieRegistry } from "@/services/cookieRegistry";

let identifier: string | undefined = undefined;

export function useAnonymousIdentifier() {
  const getIdentifier = (): string => {
    if (identifier === undefined) {
      const { name, expirationDays } = CookieRegistry[CookieName.AnonymousIdentifier];
      identifier = getCookie(name) ?? crypto.randomUUID();

      const expiration = new Date();
      expiration.setDate(expiration.getDate() + expirationDays);
      setCookie(name, identifier, { expiration: expiration.toUTCString(), path: "/", secure: import.meta.env.PROD });
    }
    return identifier;
  };

  return { getIdentifier };
}
